import { Tooltip } from '@mui/material';
import { CSSProperties, PropsWithChildren, ReactNode } from 'react';

type DisabledToolipProps = PropsWithChildren & {
  /** Text to display in the tooltip, tooltip will not render when message is undefined */
  message?: string | ReactNode;
  /** Styles to apply to the tooltip wrapper */
  className?: string;
  placement?: 'right' | 'left' | 'bottom' | 'top';
  /** Additional styles to apply to the inner span wrapper */
  wrapperStyle?: CSSProperties;
};

/**
 * Wrapper around the MUI Tooltip that provides an inner Div element allowing the tooltip to render when there is a disabled element within.
 */
export default function DisabledTooltip(props: DisabledToolipProps) {
  /** Avoid rendering unless needed */
  if (!props.message) {
    return props.children;
  }

  //div wrapper around children is required for tooltip to show up when child element is disabled
  return (
    <Tooltip
      title={props.message}
      className={props.className}
      placement={props.placement}>
      <span style={{ display: 'flex', ...props.wrapperStyle }}>{props.children}</span>
    </Tooltip>
  );
}
